module.exports = __webpack_public_path__ + "img/pic_nodate@2x.803b72c5.png";